module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/campaign_eight-63aaf16a32fc733aec6efe1060c6eb6e.png";